import { render, staticRenderFns } from "./user-profile.vue?vue&type=template&id=3551b5be&scoped=true"
import script from "./user-profile.vue?vue&type=script&lang=js"
export * from "./user-profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3551b5be",
  null
  
)

export default component.exports